import React, {useEffect, useState} from 'react';
import classes from "./roadmap.module.css";
import {texts} from "../../../../translate";
import {getRanks} from "../../../../utils/api";
import {MEDIA_URL} from "../../../../config";

const PERKS = {
    ru: ['вступление', '+5% к лимиту', 'скидка 10%', 'скидка 25%', 'раунд на 24 ч раньше', 'скидка 50%', 'максимальный приоритет'],
    eng: ['membership', '+5% to limit', '10% discount', '25% discount', 'round 24h earlier', '50% discount', 'max priority'],
}

const Roadmap = ({lang, setActive, data}) => {
    const [ranks, setRanks] = useState([])
    const [current, setCurrent] = useState(null)

    useEffect(() => {
        getRanks().then((res) => {
            if (res?.ranks) {
                setRanks(res.ranks)
                setCurrent(res.current)
            }
        })
    }, [data])

    const currentIndex = Math.max(0, ranks.findIndex((item) => item.is_current))
    const next = ranks[currentIndex + 1]
    const t = texts[lang].roadmap
    const perks = PERKS[lang] || PERKS.ru
    const image = current?.image ? (current.image.startsWith('http') ? current.image : MEDIA_URL + current.image) : null

    return (
        <div className={classes._}>
            <div className={classes.text1}>{t.text1}</div>
            <div className={classes.steps}>{t.steps}</div>
            <div className={classes.currentCard}>
                {image ? <img src={image} alt="" className={classes.lion}/> : <div className={classes.lionStub}/>}
                <div>
                    <div className={classes.currentName}>
                        {lang === 'ru' ? (current?.lion_title || current?.title || 'Новичок') : (current?.lion_title_en || current?.title_en || 'Novice')}
                        {' · '}{currentIndex + 1} / {ranks.length || 7}
                    </div>
                    <div className={classes.bar}><div style={{width: `${Math.min(100, ((currentIndex + 1) / (ranks.length || 7)) * 100)}%`}}/></div>
                    <div className={classes.nextHint}>
                        {next ? `${t.next}: ${lang === 'ru' ? (next.lion_title || next.title) : (next.lion_title_en || next.title_en)}` : t.hint}
                    </div>
                </div>
            </div>
            <div className={classes.blocks}>
                {(ranks.length ? ranks : Array.from({length: 7})).map((item, index) => {
                    const title = item ? (lang === 'ru' ? (item.lion_title || item.title) : (item.lion_title_en || item.title_en)) : ['Новичок','Ученик','Охотник','Воин','Герой','Король','Император'][index]
                    const here = item?.is_current || index === currentIndex
                    return (
                        <div className={`${classes.rankRow} ${here ? classes.rankHere : ''}`} key={item?.id || index}>
                            <span className={classes.number}>{index + 1}</span>
                            <span className={classes.rankName}>{title}</span>
                            <span className={classes.rankPerk}>{here ? t.here : perks[index]}</span>
                        </div>
                    )
                })}
            </div>
            <p className={classes.hint}>{t.hint}</p>
            <div className={classes.invite} onClick={() => setActive(2)}>{t.invite}</div>
        </div>
    );
};

export default Roadmap;
